import { render, staticRenderFns } from "./LeaveStatus.vue?vue&type=template&id=13c89bc2&scoped=true&"
import script from "./LeaveStatus.vue?vue&type=script&lang=js&"
export * from "./LeaveStatus.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./LeaveStatus.vue?vue&type=style&index=1&id=13c89bc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c89bc2",
  null
  
)

export default component.exports